import React from 'react';
import './Logo.scss';

const Logo: React.FC = () => {
  return (
    <div className="logo">
      <div className="logo-image">
        <img src="/assets/images/peerislands-white.svg" alt="logo" />
      </div>
      <div className="divider"></div>
      <div className="logo-image peerai">
        <img src="/assets/images/peerai_white.png" alt="logo" />
      </div>
    </div>
  );
};

export default Logo;
